import React from "react"

import Layout from '../../../components/Layout';
import Loading from '../../../components/Loading';
import Error from '../../../components/Error';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import { Form, Button, Modal, FormGroup, InputGroup, ControlLabel, FormControl, ButtonToolbar } from 'react-bootstrap';
import PhoneInput, { formatPhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';


class AddHotelUserModal extends React.Component {
    constructor(props) {
        super(props)

        if (!props.isEdit) {
            this.state = {
                name: '',
                email: '',
                contact: '',
                showValidationError:false,
                modalText:''
            }
        }
        else {
            this.state = {
                name: this.props.selectedHotel.name,
                email: this.props.selectedHotel.email,
                contact: this.props.selectedHotel.contact,
                showValidationError:false,
                modalText:''
            }
        }
    }

    onContactChange = (e) => {
        this.setState({
            contact: e.target.value
        })
    }

    onEmailChange = (e) => {
        this.setState({
            email: e.target.value
        })
    }

    onNameChange = (e) => {
        this.setState({
            name: e.target.value
        })
    }


    onHide = () => {
        this.setState({
            name: '',
            email: '',
            contact: ''
        }, this.props.onClose())
    }

    onClose =()=>{
        this.setState({showValidationError:false})
    }


    addHotelContact = (e) => {
        e.preventDefault();
        if(this.state.name.trim() == ''){
            this.setState({showValidationError:true,modalText:'Please provide a name'})
            return false;
        }else if(this.state.email.trim() == ''){
            this.setState({showValidationError:true,modalText:'Please provide the email address'})
            return false;
        }else if(this.state.email != '' && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(this.state.email)){
            this.setState({showValidationError:true,modalText:'Please provide the valid email address'})
            return false;
        }else if(this.state.contact.trim() == ''){
            this.setState({showValidationError:true,modalText:'Please provide a contact'})
            return false;
        }else if(this.state.contact.trim() != '' && isNaN(this.state.contact)){
            this.setState({showValidationError:true,modalText:'Contact should be in Numeric format'})
            return false;
        }else if(!isValidPhoneNumber(this.state.contact)){
            this.setState({showValidationError:true,modalText:'Please enter valid contact Number'})
            return false;
        }

        if (this.props.isEdit) {
            this.props.editHotelContact(this.props.hotel, {
                id: this.props.selectedHotel.id,
                name: this.state.name,
                email: this.state.email,
                contact: this.state.contact
            })
        }
        else {
            this.props.addHotelContact(this.props.hotel, {
                name: this.state.name,
                email: this.state.email,
                contact: this.state.contact
            })
        }
        this.onHide()
    }

    render() {
        return (
            <div>
            <Modal show={this.props.show} onHide={this.onHide}>
                <Modal.Header closeButton>
                    <Modal.Title> {this.props.isEdit ? 'Edit Contact' : 'Add Contact'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup>
                            <InputGroup>
                                <ControlLabel>Name</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={this.state.name}
                                    onChange={this.onNameChange}
                                />
                            </InputGroup>
                            <InputGroup>
                                <ControlLabel>Email</ControlLabel>
                                <FormControl
                                    type="email"
                                    value={this.state.email}
                                    onChange={this.onEmailChange}
                                    readOnly={this.props.isEdit}
                                />
                            </InputGroup>
                            <InputGroup>
                                <ControlLabel>Contact (Please select a Country and provide Phone Number) </ControlLabel>
                                {/* <FormControl
                                    type="text"
                                    value={this.state.contact}
                                    onChange={this.onContactChange}
                                /> */}
                                <PhoneInput
                                    country="US"
                                    placeholder="Enter phone number"
                                    value={this.state.contact}
                                    onChange={value => this.setState({ contact:value })}
                                    error={ this.state.contact ? (isValidPhoneNumber(this.state.contact) ? undefined : 'Invalid phone number') : 'Phone number required' }/>
                            </InputGroup>
                        </FormGroup>
                        <FormGroup>
                            <ButtonToolbar>
                                <Button
                                    type="submit"
                                    bsStyle="success"
                                    onClick={this.addHotelContact}
                                >Save</Button>
                                <Button
                                    bsStyle="success"
                                    onClick={this.onHide}
                                >
                                    Cancel
                             </Button>
                            </ButtonToolbar>
                        </FormGroup>
                    </Form>
                </Modal.Body>
                <Modal.Footer />
            </Modal>
        {this.state.showValidationError && (<Modal show={this.state.showValidationError} onHide={this.onClose}>
            <Modal.Header closeButton>
              <Modal.Title>Incorrect data</Modal.Title>
            </Modal.Header>
            <Modal.Body>
  
              <p> {this.state.modalText !== '' ? this.state.modalText : 'Please enter valid data.'}</p>
  
              <ButtonToolbar style={{ float: 'right' }}>
                <Button
                  bsStyle="success"
                  onClick={this.onClose}
                >
                              Ok
                            </Button>
              </ButtonToolbar>
            </Modal.Body>
            <Modal.Footer style={{ clear: 'both' }} />
          </Modal>
          )}
     </div>
     )     
    }
}
class HotelUsers extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            showAddUser: false,
            hotel: {},
            isEdit: false,
            selectedHotel: {}
        }

        // editHotelContact
    }
    componentWillMount() {
        if (this.props.needFetch) {
            this.props.requestHotel(this.props.id);
        }
        if (this.props.hotel) {
            if (this.props.hotel.id !== this.props.id) {
                this.props.requestHotel(this.props.id);
            }
        }
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.id !== nextProps.id) {
            nextProps.requestHotel(this.props.id);

        }
    }


    displayAddContactModal = () => {
        this.setState({
            isEdit: false,
            showAddUser: true
        })
    }

    hideAddContactModal = () => {
        this.setState({
            isEdit: false,
            showAddUser: false
        })
    }

    deleteContact = (row) => {
        this.props.removeHotelContact(this.props.hotel.id, { user: row.id })
    }

    editContact = (row) => {
        this.setState({
            isEdit: true,
            showAddUser: true,
            selectedHotel: row
        })
    }
    buttonFormatter = (cell, row) => <div>
        <ButtonGroup>
            <Button bsStyle="primary"
                onClick={() => this.editContact(row)}
            >
                <i className="fa fa-pencil fa-lg" />
            </Button>
            <Button bsStyle="danger"
                onClick={() => this.deleteContact(row)}
            >
                <i className="fa fa-trash-o fa-lg" />
            </Button>
        </ButtonGroup>
    </div>;

    render() {
        if (this.props.hasError) {
            return (
                <Layout>
                    <Error />
                </Layout>
            );
        }
        if (this.props.needFetch || this.props.isFetching) {
            return (
                <Layout>
                    <Loading />
                </Layout>

            );
        }

        const userdata = [];
        this.props.hotel.contacts.map(c => {
            userdata.push({
                id: c.id,
                name: `${c.first_name} ${c.last_name}`,
                email: c.email,
                contact: c.profile.mobile
            })
        })
        return (
            <div className="content-tours">
                {this.state.showAddUser && <AddHotelUserModal
                    show={this.state.showAddUser}
                    onClose={this.hideAddContactModal}
                    addHotelContact={this.props.addHotelContact}
                    hotel={this.props.hotel.id}
                    isEdit={this.state.isEdit}
                    selectedHotel={this.state.selectedHotel}
                    editHotelContact={this.props.editHotelContact}
                />}
                <div className="container-fluid">
                    <div className="row tour-head">
                        <div className="col-md-12 tour-headText">
                            <h2>{this.props.hotel.name}</h2>
                            <hr />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Button
                                bsStyle="success"
                                type="button"
                                style={{ float: "right",marginBottom:10 }}
                                onClick={this.displayAddContactModal}
                            >
                                Add
                            </Button>
                        </div>
                        <div className="col-md-12">
                            <BootstrapTable
                                data={userdata}
                                striped
                                hover
                                condensed
                            >
                                <TableHeaderColumn dataField="id" isKey hidden hiddenOnInsert={true}>Product ID</TableHeaderColumn>
                                <TableHeaderColumn dataField="name">Name</TableHeaderColumn>
                                <TableHeaderColumn dataField="email">Email</TableHeaderColumn>
                                <TableHeaderColumn dataField="contact">Contact</TableHeaderColumn>
                                <TableHeaderColumn dataField="editBid" width="100" headerAlign="center" dataAlign="center" dataFormat={this.buttonFormatter} editable={false}>Action</TableHeaderColumn>
                            </BootstrapTable>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default HotelUsers


// WEBPACK FOOTER //
// src/routes/hotels/components/HotelUsers.js